import path from "utils/path";

export default function useRepoLinks() {
  return {
    dashboardLink: path("dashboard"),
    accountLink: path("accounts"),
    licensesLink: path("licenses.templates"),
    systemLink: path("system"),
    versionsLink: path("essentials.versions"),
    packagesLink: path("packages"),
    pushCentersLink: path("push_centers"),
    incrementalUpgradeLink: path("iu_versions"),
    systemEventsPath: path("system.events"),
    systemServices: path("system.services"),
    systemSettings: path("system.settings"),
    actionLogLink: path("action_log"),
  };
}
